import { KeenSliderInstance, KeenSliderOptions, KeenSliderPlugin } from "keen-slider";

/**
 * Export KeenSlider Plugin
 * @param slider 
 */
export default function(target: HTMLElement, options: KeenSliderOptions): KeenSliderPlugin {
    return (slider: KeenSliderInstance) => {

    };
};
